// ui/GradientText.js
import React from "react";
import { Typography } from "@mui/material";

const GradientText = ({ children, ...props }) => {
  return (
    <Typography
      {...props}
      sx={{
        background: "linear-gradient(45deg, #00ff88, #0099ff, #ff3366)",
        backgroundSize: "200% 200%",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        color: "transparent",
        animation: "gradientShift 3s ease infinite",
        "@keyframes gradientShift": {
          "0%": { backgroundPosition: "0% 50%" },
          "50%": { backgroundPosition: "100% 50%" },
          "100%": { backgroundPosition: "0% 50%" },
        },
        ...props.sx,
      }}
    >
      {children}
    </Typography>
  );
};

export default GradientText;